import { cva, type VariantProps } from 'class-variance-authority';

/**
 * Callout shell. `primary` / `secondary` tint the surface; the `neutral-*`
 * pair keeps a white surface and carries the accent color on the left strip
 * and icon chip.
 */
export const calloutVariants = cva(
  'relative flex w-full flex-col gap-sm rounded-md border border-l-4 px-info-card-sides py-info-card-top-bottom',
  {
    variants: {
      style: {
        primary: 'bg-primary-50 border-primary-200 border-l-primary-700',
        secondary:
          'bg-secondary-50 border-secondary-200 border-l-secondary-700',
        'neutral-primary': 'bg-white border-neutral-200 border-l-primary-700',
        'neutral-secondary':
          'bg-white border-neutral-200 border-l-secondary-700',
      },
    },
    defaultVariants: {
      style: 'primary',
    },
  },
);

/** Leading icon chip. Accent-filled in every variant; the glyph stays white. */
export const calloutIconVariants = cva(
  'flex size-5 shrink-0 items-center justify-center rounded-sm',
  {
    variants: {
      style: {
        primary: 'bg-primary-700',
        secondary: 'bg-secondary-700',
        'neutral-primary': 'bg-primary-700',
        'neutral-secondary': 'bg-secondary-700',
      },
    },
    defaultVariants: {
      style: 'primary',
    },
  },
);

export const calloutLabelVariants = cva(
  'min-w-0 truncate font-bold uppercase tracking-wide',
  {
    variants: {
      style: {
        primary: 'text-primary-700',
        secondary: 'text-secondary-700',
        'neutral-primary': 'text-primary-700',
        'neutral-secondary': 'text-secondary-700',
      },
    },
    defaultVariants: {
      style: 'primary',
    },
  },
);

export type CalloutVariantProps = VariantProps<typeof calloutVariants>;

/** Surface + accent options shared by every Callout sub-element. */
export type CalloutStyle = NonNullable<CalloutVariantProps['style']>;
